module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-600.449d681c.woff";